

















import Vue from 'vue'
import Component from 'vue-class-component'
import { Inject, Prop } from 'vue-property-decorator'
import { ProjectViewModel } from '@/business/project/interfaces/project-view-model'
import RespondecoBlock from '@/shared/components/respondeco-block.vue'
import RespondecoEditor from '@/shared/components/respondeco-editor.vue'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import { FormGroup } from '@/shared/forms/form-group'
import { EditProjectForm } from '@/business/project/components/edit-project/edit-project-form'
import RespondecoEmptyContainer from '@/shared/components/respondeco-empty-container.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'

@Component({
  components: {
    UnifyButton,
    RespondecoEmptyContainer,
    RespondecoFormGroup,
    RespondecoEditor,
    RespondecoBlock,
  },
})
export default class EditProjectLearnings extends Vue {
  @Prop({
    required: true,
    type: Object,
  })
  public readonly project!: ProjectViewModel

  @Inject()
  public readonly form!: FormGroup<EditProjectForm>

  get formControl() {
    return this.form.field('partners')
  }

  get partners() {
    return this.formControl.$model
  }

  public updateTestimonial(index: number, value: string) {
    this.formControl.$model[index].testimonial = value
    this.formControl.$touch()
  }
}
